<ng-template #clearButton>
  <span class="ng-clear ms-2 me-2">
    <fa-icon
      aria-hidden="true"
      class="cursor-pointer"
      icon="xmark"
      (click)="emitClear()"
      (keydown.enter)="emitClear()"
      (keydown.space)="emitClear()" />
  </span>
</ng-template>

<ng-template #textClearButton>
  <span
    class="ng-clear ng-clear-text ms-2 me-2"
    (click)="emitClear()"
    (keydown.enter)="emitClear()"
    (keydown.space)="emitClear()"
    >Clear all</span
  >
</ng-template>
